/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Priority_SupportInputs */



/**
* | output |
* | --- |
* | "Audit logs, SSO, team collaboration & priority support" |
*
* @param {Pricing_Feature_Priority_SupportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_priority_support = /** @type {((inputs?: Pricing_Feature_Priority_SupportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Priority_SupportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit-Logs, SSO, Team-Zusammenarbeit & priorisierter Support")
	return /** @type {LocalizedString} */ ("Audit logs, SSO, team collaboration & priority support")
});